<template>
    <div id="mail-users">
        <div v-if="visitors.length >0">
            <a-table
                :key="'vtable-' + renderCount"
                :columns="cols"
                :dataSource="visitors"
                :pagination="false"
                :rowClassName="getRowClassName"
                :loading="loading"
                :locale="{
                emptyText: $t('message.noVisitorFound'),
            }"
                rowKey="_id"
                size="small"
            >
                <template slot="fullname" slot-scope="text, record">
                    <div class="avatar-cell">
                    <span
                        class="user-segment-avatar text-center"
                        :class="{ 'user-segment-avatar-odd': isRowNumberOdd(record) }"
                    >
                        <md-highlight-text md-term="term" class="text-center">
                            {{ record.fullname ? record.fullname.slice(0, 1).toUpperCase() : "" }}
                        </md-highlight-text>
                    </span>
                        <span class="white-space">
                        {{ record.fullname }}
                    </span>
                    </div>
                </template>
                <template slot="tags" slot-scope="data, item">
                <span class="tags">
                    <span class="tag" v-for="tag in data || []">
                        <span class="tag-color" :style="`background:${tag.color}`"></span>
                        {{ tag.name }}
                    </span>
                </span>
                </template>
                <template slot="connectionTime" slot-scope="data, item">
                    {{ fixDate(data) }}
                </template>
                <span :slot="value.slot" v-for="value of colValues">
                <span v-if="value['enabled'] === true">
                    <span v-if="value.icon === 'playlist_add'" style="cursor: pointer">
                        <a-popover placement="leftTop" trigger="click">
                            <template #title>
                                <a-checkbox @click="(e) => onSelectShowAllColumns(e)" :checked="showAllColumns" />
                                <span style="color: #516173; margin-left: 5px">Show in columns: </span>
                            </template>
                            <template #content>
                                <div
                                    v-for="(value, key, index) in colValues"
                                    :key="key + value + index"
                                    style="display: flex; align-items: center"
                                    @click="(e) => selectedClick(value, key, e)"
                                >
                                    <div
                                        v-if="value.title !== ''"
                                        :style="validCols.includes(value.slot) ? '' : 'cursor: pointer'"
                                        style="width: 100%"
                                    >
                                        <input
                                            type="checkbox"
                                            :checked="value['enabled']"
                                            :key="key + value['enabled']"
                                            style="margin-right: 6px"
                                            :disabled="validCols.includes(value.slot)"
                                        />
                                        <span
                                            class="material-icons mx-2 text-primary operation-button"
                                            style="color: #006cff; margin-right: 10px; font-size: 17px"
                                        >
                                            {{ value.icon }}
                                        </span>
                                        <label
                                            :for="key"
                                            class="checkbox-label"
                                            :style="validCols.includes(value.slot) ? '' : 'cursor: pointer'"
                                        >{{ value.title }}</label
                                        >
                                    </div>
                                </div>
                            </template>
                            <span class="material-icons mx-2 text-primary operation-button"> {{ value.icon }} </span>
                        </a-popover>
                    </span>
                    <span v-else style="display: flex">
                        <span class="material-icons mx-2 text-primary operation-button"> {{ value.icon }} </span>
                        {{ value.title }}
                    </span>
                </span>
            </span>
                <div :slot="'connectionTimeSlot'" slot-scope="data, item">
                    {{ item.connectionTime | date }}
                </div>
            </a-table>
            <Pagination
                :page-change="pageChange"
                :pageSizes="pageSizes"
                :total="total"
                pageSizeLocalStorageKey="visitor-history-page-size"
                class="pagination"
            />
        </div>
        <div class="data-box" v-else>
            <div class="last-session-info">
                <div class="material-icons" style="font-size: 20px">block</div>
                <div class="last-session-data" style="margin-top: 5px">No user data were found</div>
            </div>
        </div>
    </div>
</template>

<script>
import { log2 } from "../../../../utils/log2";
import Pagination from "../../../../../src/components/Pagination";
import { mapGetters, mapState, mapActions } from "vuex";
import { tableSorter } from "../../../../utils/utils";
import * as _ from "lodash";
import moment from "moment";

const log = log2("VisitorList");
export default {
    name: "VisitorList",
    components: {
        Pagination,
    },
    props: {},
    data() {
        return {
            hoveredId: null,
            rows: [],
            colValues: [
                { title: this.$t("message.name"), slot: "fullname", icon: "person", enabled: true },
                { title: this.$t("message.email"), slot: "e-mail", icon: "alternate_email", enabled: true },
                { title: this.$t("chatbotv2.attr.platform"), slot: "platform", icon: "ads_click", enabled: true },
                { title: this.$t("chatbotv2.attr.last_seen"), slot: "lastSeen", icon: "date_range", enabled: true },
                { title: this.$t("message.firstSeen"), slot: "firstSeen", icon: "date_range", enabled: true },
                { title: this.$t("message.country"), slot: "country", icon: "location_on", enabled: false },
                { title: this.$t("message.city"), slot: "city", icon: "location_on", enabled: false },
                { title: this.$t("message.os"), slot: "os", icon: "settings_suggest", enabled: false },
                {
                    title: this.$t("message.connectionDate"),
                    slot: "connectionTime",
                    icon: "date_range",
                    enabled: false,
                },
                { title: this.$t("message.visitingPage"), slot: "visitingPage", icon: "public", enabled: false },
                { title: this.$t("message.browser"), slot: "browser", icon: "computer", enabled: false },
                { title: "Tags", slot: "tags", icon: "ads_click", enabled: false },
                { title: "", slot: "listAdd", icon: "playlist_add", enabled: true },
            ],
            renderCount: 0,
            currentSort: {
                columnKey: "connectionTime",
                order: "ascend",
            },
            cols: [
                {
                    dataIndex: "fullname",
                    key: "fullname",
                    slots: { title: "fullname" },
                    scopedSlots: { customRender: "fullname" },
                    ...tableSorter("fullname", "string", this.currentSort),
                },
                {
                    dataIndex: "email",
                    key: "email",
                    slots: { title: "e-mail" },
                    ...tableSorter("email", "string", this.currentSort),
                },
                {
                    dataIndex: "platform",
                    key: "platform",
                    slots: { title: "platform" },
                    ...tableSorter("platform", "string", this.currentSort),
                },
                {
                    dataIndex: "add",
                    key: "add",
                    slots: { title: "listAdd" },
                    scopedSlots: { customRender: "add" },
                },
            ],
            loading: false,
            filtersValue: null,
            visitors: [],
            validCols: ["e-mail", "fullname", "platform", "firstSeen", "lastSeen"],
            dateTypeCols: ["connectionTime"],
            showAllColumns: false,
            pageSizes: ["10", "25", "50", "100"],
            currentPage: 1,
            perPage: 10,
            total: 0,
        };
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        ...mapState({
            visitorAttributes: (state) => state.contactProperty.data || [],
        }),
    },
    async mounted() {
        const result = await this.getMailVisitors({
            id: this.$route.params.id,
            perPage: this.perPage,
            pageCount: this.currentPage,
        });
        console.log("getMailUsers result", result);
        this.total = result.allMailCount;
        this.visitors = result.findMails.map(x => x.visitorInfo[0]);
        console.log("getMailUsers this.visitors", this.visitors);
        moment.locale(this.$i18n.locale);
        this.init();
    },
    methods: {
        ...mapActions({
            getMailVisitors: "mail/getMailVisitors",
        }),
        fetch() {
            this.loading = true;
            this.getMailVisitors({
                id: this.$route.params.id,
                perPage: this.perPage,
                pageCount: this.currentPage,
            }).then((res) => {
                this.total = res.allMailCount;
                const data = res.findMails.map(x => x.visitorInfo[0]);
                this.visitors = [...this.visitors, ...data];
                this.loading = false;
            });
        },
        init() {
            this.colValues = [
                ...this.colValues,
                ...this.visitorAttributes.map((attr) => ({
                    title: attr.label,
                    slot: `contactProperty_${attr._id}`,
                    icon: "tag",
                    enabled: false,
                })),
            ];
            const selectedColumns = JSON.parse(localStorage.getItem("selectedColumns") || "[]");
            if (selectedColumns.length < 6 || _.isEqual(selectedColumns, this.cols)) {
                localStorage.getItem("selectedColumns", JSON.stringify(this.cols));
            } else {
                this.cols = selectedColumns;
                this.colValues = this.colValues.map((col) => {
                    col.enabled = !!this.cols.find((c) => c.slots?.title == col.slot);
                    return col;
                });
            }
        },
        getRowClassName(record, index) {
            let className = "";
            if (this.hoveredId === record._id) className += " hovered";
            return className;
        },
        fixDate(date) {
            if (moment().format("l") === moment(date.toString()).format("l")) {
                return moment(date.toString()).calendar();
            } else {
                return moment(date.toString()).format("MMMM D, h:mm a");
            }
        },
        async pageChange(cur, sel) {
            this.currentPage = cur;
            this.perPage = sel;
        },
        selectedClick(value, key, e) {
            e.stopPropagation();
            e.preventDefault();
            if (!this.validCols.includes(value.slot)) {
                this.colValues[key]["enabled"] = !this.colValues[key]["enabled"];
                const findValue = this.cols.findIndex((x) => x.slots.title === value.slot);
                if (findValue === -1) {
                    let newColumn = {};
                    if (value.slot === "tags" || value.slot === "connectionTime") {
                        newColumn = {
                            dataIndex: value.slot,
                            key: value.slot,
                            slots: { title: value.slot },
                            scopedSlots: { customRender: value.slot },
                            ...tableSorter(value.slot, this.dateTypeCols.includes[value.slot] ? "date" : "string"),
                        };
                    } else {
                        newColumn = {
                            dataIndex: value.slot,
                            key: value.slot,
                            slots: { title: value.slot },
                            ...tableSorter(value.slot, this.dateTypeCols.includes[value.slot] ? "date" : "string"),
                        };
                    }
                    this.cols.splice(this.cols.length - 1, 0, newColumn);
                } else {
                    this.cols.splice(findValue, 1);
                }
            }
        },
        onSelectShowAllColumns(e) {
            e.stopPropagation();
            this.showAllColumns = !this.showAllColumns;
            this.colValues.map((x, index) => {
                if (!this.validCols.includes(x.slot) && x.slot !== "listAdd") {
                    if (this.showAllColumns === true) {
                        if (x["enabled"] === false) {
                            x["enabled"] = true;
                            let newColumn = {};
                            if (x.slot === "tags") {
                                newColumn = {
                                    dataIndex: x.slot,
                                    key: x.slot,
                                    slots: { title: x.slot },
                                    scopedSlots: { customRender: x.slot },
                                    ...tableSorter(x.slot, this.dateTypeCols.includes[x.slot] ? "date" : "string"),
                                };
                            } else {
                                newColumn = {
                                    dataIndex: x.slot,
                                    key: x.slot,
                                    slots: { title: x.slot },
                                    ...tableSorter(x.slot, this.dateTypeCols.includes[x.slot] ? "date" : "string"),
                                };
                            }
                            this.cols.splice(this.cols.length - 1, 0, newColumn);
                        }
                    } else {
                        x["enabled"] = false;
                        this.cols.splice(index, this.cols.length - this.validCols.length - 1);
                    }
                }
            });
        },
        rowMouseOver(record) {
            this.hoveredId = record._id;
        },
        rowMouseLeave(record) {
            this.hoveredId = null;
        },
        isRowNumberOdd(record) {
            if (!!this.segments)
                return (this.segments.findIndex((segment) => segment._id === record._id) + 1) % 2 !== 0;
        },
    },
    watch: {
        cols: {
            handler(newVal) {
                localStorage.setItem("selectedColumns", JSON.stringify(newVal));
            },

            deep: true,
        },
        visitorAttributes: {
            handler() {
                this.init();
            },
            deep: true,
        },
        currentPage(newValue, oldValue) {
            this.fetch();
        },
        perPage(newValue, oldValue) {
            this.fetch();
        },
    },
};
</script>

<style lang="scss">
.ant-popover-inner-content {
    box-shadow: none;
    width: max-content;
}

.checkbox-label {
    padding-top: 9px;
    color: #516173;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 5px;
}

#mail-users {
    margin: 50px;
    width: 70vw;


    .pagination {
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        margin-top: 10px;
    }

    .data-box {
        border: 1px solid #dbe1e8;
        border-radius: 4px;
        -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
        box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
        padding: 25px;
        display: grid;
        width: 100%;
        min-width: 500px;
        height: 118px;

        .last-session-info {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .last-session-data {
                color: #bab5b5;
            }
        }
    }

    .tags {
        display: flex;
        gap: 5px;
        flex-wrap: wrap;

        .tag {
            padding: 5px 3px;
            user-select: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            color: #22272d;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;

            .tag-color {
                width: 15px;
                height: 15px;
                border-radius: 50%;
                display: inline-block;
                margin-right: 5px;
            }
        }
    }

    .ant-table-row {
        min-height: 52px;

        &.selected {
            background: #f9f9f9;

            td {
                background: #f9f9f9;
            }
        }

        .cbSelect {
            display: none;
            width: 35px;
            height: 35px;
            align-items: center;
            justify-content: center;
        }

        .user-segment-avatar {
            display: flex;
        }

        .avatar-cell {
            display: flex;
            align-items: center;
            gap: 5px;
        }

        &.hovered {
            .avatar-cell {
                .cbSelect {
                    display: flex;
                }

                .user-segment-avatar {
                    display: none;
                }
            }
        }
    }

    .ant-table-body td {
        border-bottom: 1px solid #e8e8e8 !important;
        padding: 10px !important;
    }

    .ant-table-body tbody td {
        border-right: none !important;
    }

    .ant-table-body th {
        border-right: none;
    }

    .ant-table-thead > tr > th {
        border-bottom: 1px solid #e8e8e8 !important;
    }

    &.multiSelect {
        .user-segment-avatar {
            display: none !important;
        }

        .cbSelect {
            display: flex !important;
        }
    }

    .webAdressMask {
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        white-space: nowrap;
        -webkit-line-clamp: 1;
        max-width: 300px;
        word-break: break-all;
    }

    .user-segment-avatar {
        display: flex;
        align-items: center;
        font-size: 16px;
        background: #6899c1;
        border-radius: 50%;
        height: 35px;
        width: 35px;
    }

    .user-segment-avatar-odd {
        display: flex;
        align-items: center;
        font-size: 16px;
        background: #c980a3;
        border-radius: 50%;
        height: 35px;
        width: 35px;
    }

    .ant-table-small {
        border: none !important;
    }

    .material-icons {
        font-size: 20px;
    }
}


</style>
<style lang="scss" scoped>
.white-space {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    display: inline-block;
}
</style>
